import * as yup from 'yup'

yup.setLocale({
  mixed: {
    required: '${path} è un campo obbligatorio',
  },
  string: {
    email: 'Email non valida',
    min: 'Valore troppo corto (minimo ${min} caratteri)',
    max: 'Valore troppo lungo (massimo ${max} caratteri)',
  },
  number: {
    min: 'Valore inválido (deve essere maggiore o uguale a ${min})',
    max: 'Valore inválido (deve essere minore o uguale a ${max})',
  },
})

export default yup
